import emailjs, { EmailJSResponseStatus } from '@emailjs/browser';

export default abstract class EmailService {
  private static serviceId = 'service_s24uxsp';
  private static templateId = 'template_esfpiq8';
  private static jobApplicationTemplateId = "template_2ohe63a";
  private static publicKey = '_BmLHXA1AjanJqMxC';

  public static async sendEmail(form: HTMLFormElement, isJobApplication?: boolean): Promise<EmailJSResponseStatus> {
    // All args except the form itself are taken from EmailJS.
    const response: EmailJSResponseStatus = await emailjs.sendForm(
      this.serviceId,
      isJobApplication ? this.jobApplicationTemplateId : this.templateId,
      form,
      { publicKey: this.publicKey }
    );

    if (response.status === 200) {
      console.log('Email is sent successfully.');
    } else {
      console.error('Unexpected error occured.', response.text);
    }

    return response;
  }
}